import axios from 'axios';
import { logout } from '../actions/auth';
import { usePayloadStore } from '@/stores/payload';
import { checkToken } from '@/actions/auth';
const _axios = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    Accept: 'application/json'
  },
  timeout: 60000
});

_axios.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error)
);

_axios.interceptors.response.use(
  async (response) => response,
  (error) => {
    if (error.response) {
      if (
        error.response.status === 401 &&
        !(window?.location?.pathname as any)?.includes('accounts') &&
        !(window?.location?.pathname as any)?.includes('signup')
      ) {
        const payloadStore = usePayloadStore();
        if (payloadStore?.payload?.token) {
          checkToken(true)
            .then(() => {
              // window.location.href = '/dashboard/documents';
            })
            .catch((err) => {
              console.log(err);
              payloadStore.clear();
              window.location.href = '/accounts/login/';
            });
        } else {
          payloadStore.clear();
          window.location.href = '/accounts/login/';
        }
      }
      // else if (error.response.status === 403) { /* empty */ }
    }
    return Promise.reject(error);
  }
);

export default async (needsAuth = true) => {
  const payloadStore = usePayloadStore();
  if (needsAuth && payloadStore.payload.token) {
    _axios.defaults.headers.common.Authorization = `JWT ${payloadStore.payload.token}`;
  }
  return _axios;
};
